module.exports = (__webpack_require__(71832))(1940);